// http://brianflove.com/2016/10/23/angular2-breadcrumb-using-router/


import { Component, inject, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { ModelChangedService } from '@app/customizer/customizer';
import { IBreadcrumb } from '@models/ibreadcrumb';
import { TranslatePipe } from '@ngx-translate/core';
import { BreadcrumbService } from '@services/breadcrumb.service';
import { ModalService } from '@services/modal.service';
import { NavigateService } from '@services/navigate.service';
import { UrlConstants } from '@shared/url-constants';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';

@Component({
	selector: 'breadcrumb',
	styleUrls: ['./breadcrumb.scss'],
	templateUrl: 'breadcrumb.html',
	imports: [TranslatePipe],
	changeDetection: ChangeDetectionStrategy.Eager,
	standalone: true
})
export class BreadcrumbComponent implements OnInit, OnDestroy {

	public breadcrumbs: Array<IBreadcrumb>;
	public isVisible = true;
	private subscriptions: Array<Subscription> = [];

	modelChangedService = inject(ModelChangedService);

	constructor(
		private activatedRoute: ActivatedRoute,
		private router: Router,
		private breadcrumbService: BreadcrumbService,
		private modalService: ModalService,
		private navigateService: NavigateService
	) {
		this.breadcrumbs = [];

		this.subscriptions.push(this.router.events.pipe(filter(event => event instanceof NavigationEnd)).subscribe((event: NavigationEnd) => {
			this.getBreadCrumbs();
		}));

		this.modelChangedService.modelChanged.subscribe(m => {
			if (m) {
				let lastBC = this.breadcrumbs.last();

				if (lastBC) {
					lastBC.label = m;

					lastBC.params = {
						'brandMode': lastBC.params['brandMode'],
						'modelName': m,
						'productLine': lastBC.params['productLine']
					};

					let prevModel = lastBC.url.substring(lastBC.url.length - 4);
					lastBC.url = lastBC.url.replace(prevModel, m);
				}
			}
		});
	}

	ngOnInit() {
		this.getBreadCrumbs();
	}

	ngOnDestroy() {
		this.subscriptions.forEach(x => x.unsubscribe());
	}

	rootNavigated() {
		this.breadcrumbService.breadcrumbClicked();
	}

	getBreadCrumbs() {
		const root: ActivatedRoute = this.activatedRoute.root;

		this.breadcrumbs = this.breadcrumbService.getBreadcrumbs(root);

		// ### IF WE ONLY WANT THE PARENTS AND NOT THE ELEMENT ITSELF
		// this.breadcrumbs = this.breadcrumbs.slice(0, this.breadcrumbs.length - 1);
		this.isVisible = this.breadcrumbs.length > 0;
	}

	async goToLink(breadcrumb: IBreadcrumb) {
		this.modalService.closeAll();

		if (breadcrumb.url === '/' || breadcrumb.url === '') {
			if (breadcrumb.label === 'precious') {
				return await this.navigateService.navigate([breadcrumb.label]);
			}
			else if (breadcrumb.label === UrlConstants.KIDTEEN) {
				return await this.navigateService.navigate([breadcrumb.label]);
			}
			else {
				return await this.navigateService.navigateToHome();
			}
		}

		const path = breadcrumb.url.split('/').filter(s => s !== '');

		if (path.first() === 'tools') {
			if (path.find(x => x === 'accessories')) {
				if (path.last() === 'accessories') {
					this.breadcrumbs.last().label === 'cases' && await this.navigateService.navigate([...path, 'group', 'accessories']);
				}

				return await this.navigateService.navigate(path);
			}

			return await this.navigateService.navigate([path[0]]);
		}

		let index = path.indexOf(breadcrumb.label);

		if (index !== -1 && breadcrumb.label !== 'spirit') {
			const adjustedPath = path.slice(0, index + 1);
			return await this.navigateService.navigate(adjustedPath);

		}

		return await this.navigateService.navigate(path);
	}

}
